var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelgium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_1487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42953 0H-2V20H9.42953V0Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8591 0H9.42955V20H20.8591V0Z",
    fill: "#F7DE28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2819 0H20.8523V20H32.2819V0Z",
    fill: "#DA1F26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelgium);
export default __webpack_public_path__ + "static/media/Belgium.d37a05d1ba4518e3469747f0465ab00e.svg";
export { ForwardRef as ReactComponent };